export default `
  mutation ReorderTasks($tasks: [JSON]) {
    reorderTasks(tasks: $tasks) {
      id,
      active,
      name,
      type,
      version,
      env,
      showByDefault
      pushedAt,
      data {
        ...on NotePion {
          type,
          payload {
            title,
            content,
          }
        }
        ...on PhotoPion {
          type,
          payload {
            title,
            files,
          }
        }
        ...on PDFPion {
          type,
          payload {
            title,
            file,
          }
        }
        ...on UrlPion {
          type,
          payload {
            title,
            url,
          }
        }
        ...on YoutubePion {
          type,
          payload {
            title,
            url,
          }
        }
        ... on ActionPion {
          type,
          payload {
            actionType,
            title,
            content,
            redButtonText,
            greenButtonText,
            url,
          }
        }
        ...on TipPion {
          type,
          payload {
            actionType,
            title,
            content,
            url,
            intercom,
            file,
          }
        }
        ... on FeedArticle {
          title,
          subtitle,
          image,
          publisherLogo,
          premium,
          categories,
          url,
          value,
          actionType,
          subType,
          orderDate,
        }
        ... on TasksList {
          title,
          alterTitle,
          description,
          categories,
          color,
          icon,
          image,
          tasks,
        }
        ... on SuggestedAction {
          title,
          icon,
          categories,
          order,
          pinToBottom,
          action,
        }
        ... on Marketplace {
          title,
          image,
          categories,
          premium,
          element,
          elementText,
          order,
          pinToBottom,
          action,
        }
        ... on MyServices {
          title,
          image,
          categories,
          premium,
          order,
          pinToBottom,
          action,
        }
        ... on Card {
          title,
          alterTitle,
          image,
          tags,
          pions {
            type,
            payload {
              title
            }
            ...on NotePion {
              type,
              payload {
                title,
                content,
              }
            }
            ...on PhotoPion {
              type,
              payload {
                title,
                files,
              }
            }
            ...on PDFPion {
              type,
              payload {
                title,
                file,
              }
            }
            ...on UrlPion {
              type,
              payload {
                title,
                url,
              }
            }
            ...on YoutubePion {
              type,
              payload {
                title,
                url,
              }
            }
            ...on TipPion {
              type,
              payload {
                actionType,
                title,
                content,
                url,
                intercom,
                file,
              }
            },
          }
        }
      }
      triggers
      noRules
      rules
      delivery
      displayConditions
      createdAt
      updatedAt
    }
  }
`;
